"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var actions = require("@caddigital/sok-reducers/lib/actions/bid/messages");
var translate_1 = require("utils/translate");
var search_1 = require("utils/search");
var Tools_1 = require("./Tools");
var List_1 = require("./List");
var Types = require("types");
var constants_1 = require("utils/constants");
require("./style.scss");
var mapDispatchToProps = function (dispatch) { return ({
    clear: function () { return dispatch(actions.clear()); }
}); };
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
function parseSearchString(location) {
    var params = queryString.parse(location.search);
    var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
    // Decode params
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        params[key] = decodeURIComponent(params[key]);
    }
    return params;
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(undefined, mapDispatchToProps), (0, recompose_1.withState)('queryParams', 'setQueryParams', {}), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var params = parseSearchString(this.props.location);
        var url = this.props.location.pathname +
            (0, search_1.getQueryParams)(__assign(__assign({}, List_1.defaultParams), params));
        this.props.history.replace(url);
        this.props.setQueryParams(params);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            var params = parseSearchString(this.props.location);
            var updatedParams = __assign(__assign({}, List_1.defaultParams), params);
            this.props.setQueryParams(updatedParams);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.queryParams !== nextProps.queryParams ||
            this.props.location.search !== nextProps.location.search) {
            return true;
        }
        return false;
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var searchTimer;
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'search-box-right' }, props.queryParams.search !== undefined &&
        props.queryParams.search !== '' && (React.createElement(sok_ui_1.Icon, { onClick: function () {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: undefined })));
            props.setSearchString(null);
        }, className: 'fa-times' }))));
};
var SearchArea = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setSearchString', null), recompose_1.pure)(function (props) { return (React.createElement("div", null,
    React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('portal/bidView/search'), onBlur: function () {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            if (props.searchString !== null) {
                props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: props.searchString })));
                props.setSearchString(null);
            }
        }, value: (props.searchString !== null
            ? props.searchString
            : props.queryParams.search) || '', onKeyDown: function (event) {
            if (event.key === 'Enter') {
                if (searchTimer) {
                    clearTimeout(searchTimer);
                }
                if (props.searchString !== null) {
                    props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: props.searchString })));
                    props.setSearchString(null);
                }
            }
        }, onChange: function (e) {
            var value = e.target.value;
            props.setSearchString(value);
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            searchTimer = setTimeout(function () {
                props.update((0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: value })));
            }, constants_1.SEARCH_TIMEOUT);
        }, icon: React.createElement(sok_ui_1.Icon, { key: 'icon', className: 'fa-search' }), iconRight: clearSearchCross(props) }))); });
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'bid-messages-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids") }, props.currentBriefcase.name),
                        React.createElement("span", null, props.currentBid.name),
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/messages") }, (0, translation_1.getLocalization)('breadcrumb/sokobid/messages'))),
                    React.createElement(SearchArea, { queryParams: props.queryParams, update: props.history.push }),
                    React.createElement("div", { className: 'tools-row' },
                        React.createElement(sok_ui_1.Button, { color: 'blue', size: 'large', onClick: function () {
                                return props.history.push(props.location.pathname +
                                    (0, search_1.getQueryParams)(__assign({}, List_1.defaultParams)));
                            } }, (0, translation_1.getLocalization)('bid/MessagesView/clearFilters'))),
                    React.createElement(List_1.MessageList, { currentBid: props.currentBid, currentBriefcase: props.currentBriefcase, queryParams: props.queryParams, pathname: props.location.pathname, updateUrl: props.history.push })))),
        React.createElement(Tools_1.Tools, { currentBid: props.currentBid, currentBriefcase: props.currentBriefcase })));
});
